module.exports = __webpack_public_path__ + "static/img/logo15.abda8603.png";